module.exports = __webpack_public_path__ + "img/pro_five_9.95a0b082.jpg";